import AppStoreH from "../components/AppStoreH";
import BannerH from "../components/TopBannerH";
import AboveAppstoreH from "../components/aboveappH";
import WrittenH from "../components/WrittenH";
import MainContH from "../components/MiancontH";

function HealthCareProducts(){
    return(
        <>
        
        <BannerH/>
        <MainContH/>
         <WrittenH/>
         <AboveAppstoreH/>
        <AppStoreH/>
        </>
    )
}

export default HealthCareProducts;